import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

function Home() {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLoginClick = () => {
    if (token) {
      alert("You're already logged in!");
    } else {
      navigate("/login");
    }
  };

  const handleIdentifyClick = () => {
    if (!token) {
      alert("Please log in to start identifying birds.");
      navigate("/login");
    } else {
      navigate("/identify");
    }
  };

  const handleJournalClick = () => {
    if (!token) {
      alert("Please log in to view your journal.");
      navigate("/login");
    } else {
      navigate("/journal");
    }
  };

  return (
    <div className="container">
      <h1>Welcome to RaptorID 🦅</h1>
      <p>Identify UK birds of prey using AI and your own descriptions or photos. Save sightings and build your birdwatching journal.</p>

      <button onClick={handleIdentifyClick}>Start Identifying</button>
      <br /><br />
      <button onClick={handleLoginClick}>Login</button>
      <br /><br />
      <button onClick={handleJournalClick}>My Journal</button>

      <footer style={{ textAlign: "center", marginTop: "40px", fontSize: "14px", color: "#444" }}>
        Made with 🦅 and 🌿 by Louise
      </footer>

    </div>
  );
}

export default Home;
